import { defineCapability } from './internal';
import { args } from '../common/args';
export const UPDATE_THIRD_PARTY_CALL_STATUS_CAP = defineCapability({
  name: 'UPDATE_THIRD_PARTY_CALL_STATUS_CAP',
  args: {
    renderThirdPartyCallIcon: args.optional(args.bool())
  }
});